import { useMutation } from '@tanstack/react-query';

import { BatchCustomsStateNotificationType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  filterType: BatchCustomsStateNotificationType;
}

export const useRetrieveDeclarationByNotification = () =>
  useMutation({
    mutationFn: async ({ batchId, filterType }: HookProps): Promise<string | undefined> => {
      try {
        const { data } = await request({
          path: 'declarations/retrieve-declaration-by-notification',
          method: 'POST',
          authenticate: true,
          dataObject: { batchId, filterType },
        });

        return data.declarationId ? `/declarations/${data.declarationId}/customs-state?source=batches&all-statuses=false` : undefined;
      } catch (error) {
        showErrorToast(error, 'Failed getting the first declaration');
        return undefined;
      }
    },
  });
